import React, { FC } from 'react'

const CopyOutlinedIcon: FC<{
    className?: string
}> = ({ className = '' }) => (
    <svg
        width="10"
        height="12"
        viewBox="0 0 10 12"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill="currentColor"
            d="M3.37532 9.88235C3.05062 9.88235 2.77956 9.77365 2.56215 9.55624C2.34473 9.33882 2.23579 9.06753 2.23532 8.74235V1.14C2.23532 0.815294 2.34426 0.544235 2.56215 0.326824C2.78003 0.109412 3.05109 0.000470588 3.37532 0H8.86003C9.18474 0 9.45579 0.108941 9.67321 0.326824C9.89062 0.544706 9.99956 0.815765 10 1.14V8.74235C10 9.06706 9.89132 9.33835 9.67391 9.55624C9.4565 9.77412 9.18521 9.88282 8.86003 9.88235H3.37532ZM3.37532 9.17647H8.86003C8.96826 9.17647 9.06779 9.13129 9.15862 9.04094C9.24944 8.95059 9.29462 8.85106 9.29415 8.74235V1.14C9.29415 1.03176 9.24897 0.932235 9.15862 0.841412C9.06826 0.750588 8.96873 0.705412 8.86003 0.705882H3.37532C3.26709 0.705882 3.16756 0.751059 3.07674 0.841412C2.98591 0.931765 2.94073 1.03129 2.94121 1.14V8.74235C2.94121 8.85059 2.98638 8.95012 3.07674 9.04094C3.16709 9.13176 3.26662 9.17694 3.37532 9.17647ZM1.25768 12C0.93297 12 0.661911 11.8913 0.444499 11.6739C0.227087 11.4565 0.118146 11.1852 0.117676 10.86V2.55176H0.823558V10.86C0.823558 10.9682 0.868735 11.0678 0.959087 11.1586C1.04944 11.2494 1.14897 11.2946 1.25768 11.2941H7.44826V12H1.25768Z"
        />
    </svg>
)

export default CopyOutlinedIcon
